import React from 'react';

const Context = React.createContext('0');

export default Context;
